import {
  createOrganizationUserService,
  Filters,
  OrganizationUser,
  OrganizationUserInput,
  OrganizationUserStudentsResponse,
} from "toptaal-shared"
import apiClient from "../client"
import {
  OrganizationUserMeResponse,
  PaginatedOrganizationUsersResponse,
} from "toptaal-shared"

export async function getFilteredOrganizationUsers(filters: Filters) {
  return await apiClient
    .post<PaginatedOrganizationUsersResponse>("organization_users/filters", {
      json: filters,
    })
    .json()
}

export async function getOrganizationUser() {
  return await apiClient
    .get<OrganizationUserMeResponse>("organization_users/me")
    .json()
}

export async function getOrganizationUserById({
  organizationUserId,
}: {
  organizationUserId: OrganizationUser["id"]
}) {
  return await apiClient
    .get<OrganizationUserMeResponse>(`organization_users/${organizationUserId}`)
    .json()
}

export async function getOrganizationUserStudentsOrganization({
  organizationUserId,
}: {
  organizationUserId: OrganizationUser["id"]
}) {
  return await apiClient
    .get<OrganizationUserStudentsResponse>(
      `organization_users/${organizationUserId}/students`,
    )
    .json()
}

export async function createOrganizationUser(
  organizationUser: OrganizationUserInput,
) {
  return await apiClient
    .post("organization_users", { json: { organizationUser } })
    .json()
}

export async function updateOrganizationUser({
  organizationUserId,
  organizationUser,
}: {
  organizationUserId: OrganizationUser["id"]
  organizationUser: Partial<OrganizationUserInput>
}) {
  return await apiClient
    .put(`organization_users/${organizationUserId}`, {
      json: { organizationUser },
    })
    .json()
}

const organizationUsers = createOrganizationUserService({
  baseEndpoint: "customer_managers",
})

export const listOrganizationUsers = (filters?: Filters) =>
  organizationUsers.list(filters)
export const connectOrganizationUsersBulk = organizationUsers.connectBulk
export const connectStudentOrganizationUsersBulk =
  organizationUsers.connectStudentBulk
